import { createContext, type PropsWithChildren, useContext } from "react";
export type FormFieldOptionsContextType = {
  hideOptionalLabel?: boolean;
};
export const FormFieldOptionsContext = createContext<FormFieldOptionsContextType>({
  hideOptionalLabel: false
});
export const FormFieldOptionsProvider = ({
  hideOptionalLabel,
  children
}: PropsWithChildren<FormFieldOptionsContextType>) => {
  return <FormFieldOptionsContext.Provider value={{
    hideOptionalLabel
  }} data-sentry-element="FormFieldOptionsContext.Provider" data-sentry-component="FormFieldOptionsProvider" data-sentry-source-file="FormFieldOptionsProvider.tsx">
      {children}
    </FormFieldOptionsContext.Provider>;
};
export const useFormFieldOptions = () => {
  return useContext(FormFieldOptionsContext);
};